export const EdiFAQRoute = {
  path: '/EDI/FAQ',
  load: () => import('./EDIFAQ'),
  protected: true,
};
